export default __webpack_public_path__ + "static/media/home-gray.a63b55f7.svg";